import { render } from "./CategoryStep.vue?vue&type=template&id=2a43a45e"
import script from "./CategoryStep.vue?vue&type=script&lang=js"
export * from "./CategoryStep.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__